// extracted by mini-css-extract-plugin
export default {"NotificationIcon":"NotificationIcon_NotificationIcon__sU+vx","NotificationsUnseen":"NotificationIcon_NotificationsUnseen__mT7yv"};